import React, { useEffect, useState } from "react";
import "../../../../component/AccountAttributes/List/AccountList.css";
import "../../../Dashboard/Sidebar";
import Header from "../../../layout/header";
import DashboardMenu from "../../../layout/dashboardMenu";
import '../../../main_2.css'
import SearchLocation from "../../../searchLocation/searchLocation";
import BusinessImage from '../../../../Images/business.webp'
import {toast} from "react-toastify";
import Loader from "../../../../Loader/Loader";
import contentLoading from "../../../../Images/load_content.gif";
import NotFoundData from "../../../../Images/no-data-found.webp";

const SearchUniverseBusiness = (
    {
        match,
        dropdownData,
        dropdownValue = [],
        infraProject,
        infraProjectResponse =[],
        saveInfraProject,
        saveBusiness=[]
    }
) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isContentLoading, setIsContentLoading] = useState(false)
    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });
    const [accountTypes, setAccountTypes] = useState([])
    const [open, setOpen] = useState(false);
    const [projectType, setProjectType] = useState(null)
    const [disableSearch, setDisableSearch] = useState(true)
    const [showCreateProjectButton, setShowCreateProjectButton] = useState(false)

    useEffect(() => {
        (async () => {

        })()
    }, [])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await dropdownData()
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (dropdownValue?.account_project_type !== undefined) {
            setAccountTypes(dropdownValue?.account_project_type)
        }

    }, [dropdownValue])

    const handleCurrentLocationBlur = async (latlng = null) => {
        if (latlng?.lat === null || latlng?.lng === null) {
            toast.warning("Please choose location")
            return false
        }

        if(projectType === null){
            return false
        }

        if(latlng?.lat){
            setShowCreateProjectButton(true)
            setIsContentLoading(true)
            setIsLoading(true)
            await infraProject(projectType, latlng?.lat, latlng?.lng)
            setIsLoading(false)
        }
    };

    const handleCurrentLocationChange = async (value) => {
    };

    const handleConfirmationModal = () => {
        setOpen(true)
    }

    const redirectToAddProject = () => {
        window.location.href="add-account"
    }

    const handleSaveBusiness = async (infraId, e) => {
        e.preventDefault()
        setIsLoading(true)
        await saveInfraProject({infra_id: infraId})
        setIsLoading(false)
    }

    useEffect(() => {
        if(parseInt(saveBusiness.status) === 400){
            toast.error(saveBusiness.message)
        } else if(saveBusiness?.data){
            window.location.href = `opportunity-list/${saveBusiness?.data}`
        }
    }, [saveBusiness])

    useEffect(() => {
        if(infraProjectResponse?.data && Object.keys(infraProjectResponse).length > 0){
            setTimeout(() => {
                setIsContentLoading(false)
            }, 1000)
        }
    }, [infraProjectResponse])

    return (
        <>
            <Loader isLoading={isLoading}/>
            {isContentLoading &&
                <div className="loader-wrapper">
                    <img
                        className="loader-img"
                        src={contentLoading}
                        alt="Loading..."
                        style={{opacity:"0.5"}}
                    />
                </div>
            }
            {open &&
                <>
                    <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog"
                         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLongTitle">Confirmation</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" onClick={() => {setOpen(false)}}>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    Are you sure you want to make new project?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => {setOpen(false)}}>Close
                                    </button>
                                    <button type="button" className="btn btn-primary" onClick={redirectToAddProject}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            <div id="wrapper">
                <DashboardMenu />

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Project'}
                        />
                        {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row b-13">
                                </div>
                                {infraProjectResponse.length === 0 &&
                                    <div className="row">
                                        <img src={BusinessImage} className="business-account" />
                                    </div>
                                }

                                <div className="col-sm-12 col-md-6 float-field mt-3">
                                    <select className="form-control"
                                            onChange={(e) => {
                                                setProjectType(e.target.value)
                                                setDisableSearch(false)
                                            }} required>
                                        <option value="">Select Account Type</option>
                                        {accountTypes !== [] &&
                                            accountTypes.map((val) => {
                                                return (
                                                    <option
                                                        value={val?.id}>{val.name}</option>
                                                )
                                            })}
                                    </select>

                                    <label className="large-label float-lb">
                                        Account Type <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                                <SearchLocation
                                    handleCurrentLocationBlur={handleCurrentLocationBlur}
                                    // isError={isInputError.crl}
                                    value={optOption.currentLocation}
                                    handleCurrentLocationChange={handleCurrentLocationChange}
                                    isView={disableSearch}
                                    // setPincodeValue={setPincodeValue}
                                    label={"Search for your project"}
                                    astrickIcon={false}
                                />

                                {infraProjectResponse?.data && infraProjectResponse?.data.length === 0 &&
                                    <>
                                        <img src={NotFoundData} className="not-found-data" alt=""/>
                                        <div className="text-center" style={{ "width": "100%" }}>
                                            Data Not Found
                                        </div>
                                    </>
                                }
                                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-12 col-sm-12 d-flex mt-20px">
                                            <div className="row">
                                                {infraProjectResponse?.data && Object.keys(infraProjectResponse?.data).length > 0 &&
                                                    infraProjectResponse?.data.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-sm-4" key={i}>
                                                                    <div className="card-big-shadow">
                                                                        <div className="card card-just-text" data-background=""
                                                                             data-color=""
                                                                             data-radius="none">
                                                                            <div className="content">
                                                                                <h6 className="category mrg-b-12">
                                                                                    <div className="row">
                                                                                        <div className="col-10" style={{
                                                                                            color: "#000",
                                                                                            fontSize: "20px",
                                                                                            textAlign: "left",
                                                                                            paddingLeft: "20px"
                                                                                        }}>
                                                                                            <div className="d-flex">
                                                                                                {/*{parseInt(val?.is_draft) === 1 &&*/}
                                                                                                {/*    <div className="draft">D&nbsp;&nbsp;</div>*/}
                                                                                                {/*}*/}
                                                                                                {val?.project_name}
                                                                                            </div>

                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row list-view">
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fas fa-address-card"></i>&nbsp;&nbsp;Address
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6">{val?.address}</div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fas fa-city"></i>&nbsp;&nbsp;City
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6">{val?.city}</div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fa fa-map-marker"
                                                                                                   aria-hidden="true"></i>
                                                                                                &nbsp;&nbsp;State
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6">{val?.state}</div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fa fa-map-pin"
                                                                                                   aria-hidden="true"></i>
                                                                                                &nbsp;&nbsp;Pincode
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6">{val?.pincode}</div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fas fa-paint-brush"></i>&nbsp;&nbsp;Infra ID
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6">{val?.project_id}</div>
                                                                                        </div>
                                                                                        <div className="mb-flex">
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                                <i className="fa fa-road"
                                                                                                   aria-hidden="true"></i>
                                                                                                &nbsp;&nbsp;Distance
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-md-6 col-sm-6">{val?.distance_from_source.toFixed(2)} M</div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <hr />
                                                                                    <a href="#" onClick={(e) => {handleSaveBusiness(val?.project_id, e)}} className="business-project-select">Select</a>
                                                                                </h6>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </div>
                                        </div>
                                        {showCreateProjectButton &&
                                            <button className="btn-block business-project-select create-project mt-5" onClick={handleConfirmationModal} data-toggle="modal" data-target="#exampleModalCenter">
                                                Create New Project
                                            </button>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section ends */}
        </>
    )
}

export default SearchUniverseBusiness